const getFileNameFromUrl = (url) => {
  try {
    const pathname = new URL(url).pathname;
    let fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    while (fileName.includes("%")) {
      const decoded = decodeURIComponent(fileName);
      if (decoded === fileName) break;
      fileName = decoded;
    }
    return fileName;
  } catch {
    return "document";
  }
};

export const downloadFile = async (url, name = "") => {
  if (!url) return;

  let fileName = name;
  if (!fileName) {
    fileName = getFileNameFromUrl(url);
  }

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("Download failed");

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (err) {
    console.error("fetch download failed, using direct anchor fallback:", err);
    try {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "document";
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    } catch (fallbackErr) {
      console.error("Direct anchor fallback failed:", fallbackErr);
    }
  }
};
